import { Typography } from "@suraasa/placebo-ui"
import addDays from "date-fns/addDays"
import UpdatePaymentDetailsButton from "features/SuraasaPlus/components/UpdatePaymentDetailsButton"
import { useSuraasaPlusContext } from "features/SuraasaPlus/context"
import { WarningCircleSolid } from "iconoir-react"
import { formatDate } from "utils/helpers"

const UpdatePaymentBadge = () => {
  const { subscriptionDetails } = useSuraasaPlusContext()

  const validThroughDate = subscriptionDetails?.subscription.validThrough

  return (
    <>
      <div className="flex flex-col items-start justify-between gap-2 rounded-lg bg-warning-50 p-2 md:flex-row md:items-center">
        <div className="flex items-start gap-2">
          <WarningCircleSolid className="size-2.5 shrink-0 text-warning-600" />
          <div>
            <Typography variant="title4" className="mb-1 text-warning-900">
              We couldn&apos;t process your payment for Suraasa Plus.
            </Typography>
            {validThroughDate && (
              <Typography variant="smallBody" className="text-warning-900">
                Please update your billing details to avoid losing access.
                We&apos;ll retry until{" "}
                {formatDate(
                  addDays(
                    new Date(validThroughDate),
                    subscriptionDetails?.subscription.gracePeriod || 0
                  )
                    .toISOString()
                    .split("T")[0],
                  "dd MMMM yyyy"
                )}
                .
              </Typography>
            )}
          </div>
        </div>
        <UpdatePaymentDetailsButton className="ml-4.5 shrink-0 rounded-[10px] bg-warning-900 px-1.5 py-1 text-surface md:ml-0" />
      </div>
    </>
  )
}

export default UpdatePaymentBadge
